import DemoGuidewireExperiment from './providers/DemoGuidewireExperiment';
import GoogleExperiment from './providers/GoogleExperiment';
import AbExperimentSegmentationDirective from './AbExperimentSegmentationDirective';
import AbExperimentService from './AbExperimentService';
import 'edge/platform/base/module';

export default angular.module('edge.platform.segmentation.abexperiment', ['edge.platform.base']).provider('gwAbExperimentService', AbExperimentService).factory('gwDemoGuidewireExperiment', DemoGuidewireExperiment).factory('gwGoogleExperiment', GoogleExperiment).directive('gwAbExperimentSegmentation', AbExperimentSegmentationDirective)
// default the demo guidewire AB service to be deployed to PC - this can be overridden by a higher level module
.value('gwAbExperimentxCenter', 'pc').config(['gwAbExperimentServiceProvider', function (gwAbExperimentService) {
    gwAbExperimentService.useGoogleProvider(false);
}]);


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/segmentation/abexperiment/module.js
// module id = 1060
// module chunks = 0